import React, { useEffect, useState } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';

import { isEmpty } from 'lodash';
import template from 'url-template';

import ActionBar from '../../components/ActionBar';
import EsmsPage from '../../components/EsmsPage';
import lambdaBaseApi from '../../apis/lambda';
import RuleTargetsTable from '../../components/RuleTargetsTable';
import useApi from '../../hooks/useApi';
import useRule from '../../hooks/useRule';

import * as CoreActions from '../../actions/coreActions';

const RuleUrl = template.parse('/rules/{id}/edit');
const RuleTargetsUrl = template.parse('/rules/{id}/targets{?searchFilter,page,pageSize}');

const RuleTargetsPage = ({
    location,
    match,
    setProgressBarLoading
}) => {
    const ruleId = match.params.id;
    const companyInfo = useSelector(
        ({ companyInfo }) => companyInfo
    );
    const [rule, getRule] = useRule();

    const [redirectTo, setRedirectTo] = useState(null);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [search, setSearch] = useState();

    const [ruleTargets, getRuleTargets] = useApi((searchFilter = '') => ({
        adapter: lambdaBaseApi,
        url:     RuleTargetsUrl.expand({
            id:   ruleId,
            page: page + 1,
            searchFilter,
            pageSize
        })
    }));

    useEffect(() => {
        getRule(ruleId);
        getRuleTargets();

        return () => {
            ruleTargets.cancel();
        };
    }, []);

    useEffect(() => {
        getRuleTargets(search);
    }, [page, pageSize]);

    useEffect(() => {
        if (!ruleTargets.data) {
            setProgressBarLoading(true);
        } else {
            setProgressBarLoading(false);
        }
    }, [ruleTargets]);

    function handleSearch(searchFilter) {
        if (isEmpty(searchFilter)) {
            getRuleTargets();
            setSearch();

            return;
        }

        getRuleTargets(searchFilter);
        setSearch(searchFilter);
    }

    function linkToRule() {
        setRedirectTo({
            pathname: RuleUrl.expand(rule.data),
            search:   location.search
        });
    }

    function linkToRules() {
        setRedirectTo({
            pathname: '/rules',
            search:   location.search
        });
    }

    if (redirectTo) {
        return (
            <Redirect push to={redirectTo} />
        );
    }

    return (
        <EsmsPage
            parents={[
                companyInfo.companyName,
                rule.data.name
            ]}
            title="Rule Targets"
            handlers={[linkToRules, linkToRule]}
        >
            <ActionBar
                onSearch={handleSearch}
            />
            <RuleTargetsTable
                error={ruleTargets.error}
                isLoading={ruleTargets.loading}
                targets={ruleTargets.data || []}
                meta={ruleTargets.meta || []}
                onPageSet={setPage}
                onPageSizeSet={setPageSize}
                page={page}
                pageSize={pageSize}
            />
        </EsmsPage>
    );
};

const mapDispatchToProps = {
    ...CoreActions
};

export default withRouter(connect(null, mapDispatchToProps)(RuleTargetsPage));
